import { type FC } from 'react';
import { Grid } from 'antd';
import { Space, Text } from '@g2u/ui-kit';

import { Section, CollapsibleTextarea } from 'components';
import { type JsonDataItem, type WithOptionalDataTest } from 'types';
import styles from './account-notes-fields.module.scss';

type Props = {
  inline?: boolean;
  customer?: JsonDataItem | null;
  hasSpecialNote?: boolean;
  hasTechNote?: boolean;
} & WithOptionalDataTest;

export const AccountNotesFields: FC<Props> = (props) => {
  const { inline, customer, hasTechNote } = props;
  const { useBreakpoint } = Grid;
  const screens = useBreakpoint();

  return (
    <Section title="Notes" inline={inline}>
      <Space.$ size={Space.Size.Middle} direction={Space.Direction.Vertical}>
        <Space.$
          size={Space.Size.Large}
          direction={screens.lg ? Space.Direction.Horizontal : Space.Direction.Vertical}
          className={styles.accountNotes__instructions}
          align={Space.Align.Start}
          stretch
        >
          <CollapsibleTextarea
            dataTestId="access-notes"
            name="accessNotes"
            placeholder="Enter arrival instructions for the technician."
            label={
              <Text.$>
                Access Note: <Text.$ type="secondary">(optional)</Text.$>{' '}
              </Text.$>
            }
            buttonText="Access Note"
            maxCount={500}
            rules={[{ max: 500, message: 'Note must be up to 500 characters' }]}
            className={styles.accountNotes__instructionsItem}
            initialValue={customer?.access_notes || ''}
          />

          <CollapsibleTextarea
            dataTestId="special-notes"
            name="specialNotes"
            placeholder="Enter special notes."
            label={
              <Text.$>
                Special Note: <Text.$ type="secondary">(optional)</Text.$>{' '}
              </Text.$>
            }
            buttonText="Special Note"
            maxCount={75}
            rules={[{ max: 75, message: 'Note must be up to 75 characters' }]}
            className={styles.accountNotes__instructionsItem}
            initialValue={customer?.special_notes || ''}
          />

          {hasTechNote && (
            <CollapsibleTextarea
              dataTestId="tech-notes"
              name="techNotes"
              placeholder="Enter notes for the technician to process this job."
              label={
                <Text.$>
                  Tech Note: <Text.$ type="secondary">(optional)</Text.$>{' '}
                </Text.$>
              }
              buttonText="Tech Note"
              maxCount={500}
              rules={[{ max: 500, message: 'Note must be up to 500 characters' }]}
              className={styles.accountNotes__instructionsItem}
            />
          )}
        </Space.$>
      </Space.$>
    </Section>
  );
};
